import { makeStyles } from '@material-ui/core'
import React from 'react'
import homeIcon from 'images/components/reporter/HomeIcon.svg'
import { useHistory } from 'react-router-dom'

const homeButtonStyles = makeStyles(theme => ({
   buttonHome: {
      // position: 'absolute',
      // top: '10',
      // left: '135px',
      borderRadius: '100px',
      overflow: 'hidden',
      width: '70px',
      height: '70px',
      marginBottom: -30,
      transition: 'transform .2s',
      '&:hover': {
         transform: 'scale(1.1)',
         cursor: 'pointer'
      }
   }
}))

function HomeButton({ setShowComfirmationModal, isConfirmationModal }) {
   const history = useHistory()
   const classes = homeButtonStyles()

   function goToMundoMutual() {
      console.log('goToMundoMutual')
      history.push('/dashboard/mutual-world')
   }

   return (
      <div className={classes.buttonHome}>
         <img
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            src={homeIcon}
            alt={'Inicio'}
            onClick={() =>
               isConfirmationModal
                  ? setShowComfirmationModal(true)
                  : goToMundoMutual()
            }
         />
      </div>
   )
}

export default HomeButton
